<script setup lang="ts">
import type { DropdownMenuItem } from '@nuxt/ui'
import DsAppHeader from '~/components/ds/components/layout/AppHeader.vue'

const config = useRuntimeConfig()
const authStore = useAuthStore()

const avatarUrl = computed(() => {
  const url = authStore.user?.avatar_url
  if (!url) return undefined
  return url.startsWith('/') ? `${config.public.ssoUrl}${url}` : url
})

const userInitial = computed(() => authStore.user?.first_name?.charAt(0)?.toUpperCase() || '?')

const isDev = import.meta.dev

const userMenuItems = computed(() => {
  const items: DropdownMenuItem[][] = [
    [
      // Profil de secours : ni nom ni email à montrer, on dit pourquoi.
      authStore.profilNonVerifie
        ? { label: 'Profil non vérifié', icon: 'i-lucide-shield-alert', disabled: true }
        : { label: authStore.user?.name || '', icon: 'i-lucide-user', disabled: true },
      ...(authStore.user?.email ? [{ label: authStore.user.email, icon: 'i-lucide-mail', disabled: true }] : []),
    ],
  ]
  items.push([
    { label: 'Paramètres', icon: 'i-lucide-sliders-horizontal', to: '/parametres' },
  ])
  items.push([
    { label: 'Toutes les applications', icon: 'i-lucide-layout-grid', to: config.public.ssoUrl as string, external: true },
  ])
  items.push([
    { label: 'Déconnexion', icon: 'i-lucide-log-out', color: 'error', onSelect: () => authStore.logout() },
  ])
  return items
})
</script>

<template>
  <DsAppHeader
    icon="i-lucide-layout-dashboard"
    title="Admin Site ACC"
    :nav-items="[]"
    :user-menu-items="userMenuItems"
    :sso-apps-url="'/api/sso/apps'"
    :sso-url="config.public.ssoUrl as string"
    :avatar-url="avatarUrl"
    :user-name="authStore.user?.name"
    :user-initial="userInitial"
    :show-dev-color-picker="isDev"
  />
</template>
